import { supabase } from '../lib/supabase';
import { debounce } from './debounce';

const activeChannels = new Map();

export const subscribeToRestaurantChanges = ({
  channelName,
  table,
  restaurantId,
  callback,
  debounceMs = 400,
}) => {
  if (!restaurantId) {
    throw new Error('Restaurant context is required');
  }

  const scopedChannelName = `${channelName}_${restaurantId}`;
  const existing = activeChannels.get(scopedChannelName);
  if (existing) {
    supabase.removeChannel(existing);
    activeChannels.delete(scopedChannelName);
  }

  const debouncedCallback = debounce(callback, debounceMs);
  const filter = {
    event: '*',
    schema: 'public',
    table,
    filter: `restaurant_id=eq.${restaurantId}`,
  };

  const channel = supabase
    .channel(scopedChannelName)
    .on('postgres_changes', filter, debouncedCallback)
    .subscribe();

  activeChannels.set(scopedChannelName, channel);

  return {
    channel,
    unsubscribe: () => {
      debouncedCallback.cancel?.();
      if (activeChannels.get(scopedChannelName) === channel) {
        activeChannels.delete(scopedChannelName);
      }
      supabase.removeChannel(channel);
    },
  };
};
